module.exports = __webpack_public_path__ + "img/img_dibu@2x.c6f38a9e.png";